import { Tooltip } from 'antd'

import { cx } from '@/Ship/Helpers/cssClass'

import type { RatingDistribution } from '../Contracts/Report'

import styles from './Report.module.css'

/** Кольори балів: від червоного (1) до зеленого (5) */
export const SCORE_COLORS: Record<keyof RatingDistribution, string> = {
    '1': '#ff4d4f',
    '2': '#fa8c16',
    '3': '#fadb14',
    '4': '#95de64',
    '5': '#52c41a',
}

const SCORES: (keyof RatingDistribution)[] = ['5', '4', '3', '2', '1']

const percent = (count: number, total: number): number => (total > 0 ? Math.round((count / total) * 100) : 0)

interface RatingDistributionBarProps {
    distribution: RatingDistribution
    /** Легенда під смужкою (для підсумку) */
    withLegend?: boolean
}

/** Розподіл оцінок 1–5 однією смужкою; деталі — у підказці (і легенді) */
export const RatingDistributionBar = ({ distribution, withLegend = false }: RatingDistributionBarProps) => {
    const total = SCORES.reduce((sum, score) => sum + distribution[score], 0)
    if (total === 0) return <span className={cx(styles, 'faint')}>—</span>

    const lines = SCORES.map((score) => `${score}★ — ${distribution[score]} (${percent(distribution[score], total)}%)`)

    return (
        <div>
            <Tooltip
                title={lines.map((line) => (
                    <div key={line}>{line}</div>
                ))}
            >
                <div
                    className={cx(styles, 'distribution')}
                    role="img"
                    aria-label={`Розподіл оцінок: ${lines.join(', ')}`}
                >
                    {SCORES.filter((score) => distribution[score] > 0).map((score) => (
                        <span
                            key={score}
                            className={cx(styles, 'distributionPart')}
                            style={{
                                width: `${(distribution[score] / total) * 100}%`,
                                background: SCORE_COLORS[score],
                            }}
                        />
                    ))}
                </div>
            </Tooltip>
            {withLegend && (
                <div className={cx(styles, 'legend')}>
                    {SCORES.map((score) => (
                        <span key={score} className={cx(styles, 'legendItem')}>
                            <i className={cx(styles, 'legendDot')} style={{ background: SCORE_COLORS[score] }} />
                            {score}★ {distribution[score]}
                        </span>
                    ))}
                </div>
            )}
        </div>
    )
}
